exports = module.exports = require("../../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".DS__DropListDesktop__root {\n  box-sizing: border-box;\n  overflow: hidden;\n  background-color: #ffffff;\n  border: 1px solid #d0d6e1;\n  border-radius: 8px;\n  box-shadow: 0px 8px 16px 0px 4px 10px rgba(34, 42, 55, 0.13);\n}\n\n.DS__DropListDesktop__search {\n  display: block;\n  padding: 8px 16px;\n}\n\n.DS__DropListDesktop__subtitle-block {\n  padding: 24px 12px 0 12px;\n}\n\n.DS__DropListDesktop__subtitle-block .DS__DropListDesktop__subtitle {\n  padding-bottom: 8px;\n  text-transform: uppercase;\n}\n\n.DS__DropListDesktop__defaultOptionWrapper {\n  position: relative;\n}\n\n.DS__DropListDesktop__defaultOptionWrapper .DS__DropListDesktop__dividerWrapper {\n  position: absolute;\n  bottom: 0;\n  width: 100%;\n}\n", ""]);

// exports
exports.locals = {
	"root": "DS__DropListDesktop__root",
	"search": "DS__DropListDesktop__search",
	"subtitle-block": "DS__DropListDesktop__subtitle-block",
	"subtitle": "DS__DropListDesktop__subtitle",
	"defaultOptionWrapper": "DS__DropListDesktop__defaultOptionWrapper",
	"dividerWrapper": "DS__DropListDesktop__dividerWrapper"
};